import PropTypes from 'prop-types';
import React from 'react';

import { buildTradeSummaryData } from 'src/components/Dashboard/helpers/common';
import { renderSummaryCards } from 'src/components/Dashboard/helpers/showTradeSummary';
import Loading from 'src/components/Loading';

/**
 * Trade summary cards for a property.
 * @param {object} props
 * @param {object} props.mainData - property trade data (counterfactualAvailability, property, ...).
 * @returns {React.ReactElement} - PropertyShowTradeSummary component
 */
function PropertyShowTradeSummary({ mainData }) {
  if (!mainData) {
    return <Loading />;
  }

  const { counterfactualAvailability, property } = mainData;
  const { title } = property;

  const summaryData = buildTradeSummaryData(mainData);

  return (
    <div className="trade-summaries mb-4 row row-cols-1 row-cols-sm-2">
      {renderSummaryCards(summaryData, title, counterfactualAvailability)}
    </div>
  );
}

PropertyShowTradeSummary.propTypes = {
  mainData: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types
};

export default PropertyShowTradeSummary;
